import * as React from 'react';
import { Component } from 'react';
import handle from '../assets/img/handle.png'
import { IDropdownValues } from '../Interface/IDropdownValues';
import AdminService from '../services/AdminService';
import { Form } from '../components/shared/Form';
import tophandleimg from '../assets/img/handle.png';
import bottomhandleimg from '../assets/img/btm.png';
import HTMLParser from 'html-react-parser';
import { IPageContent } from '../Interface/IPageContent';
import { IUser } from '../Interface/IUser';
import history from "../history";


interface Props {
}

interface State {
    donateAmountList: IDropdownValues[],
    serviceBookingList: any,
    pancahngam: IPageContent[],
    instantdonate: number,
    selectedamount: number,
    isemptyemail: boolean,
    userDetail: IUser,
    selectServiceId: number,
    selectServiceTypeId: number
}
const locale = 'en';
const today = new Date();
const day = today.toLocaleDateString(locale, { weekday: 'long' });
const currentDate = `${day}, ${today.toLocaleDateString(locale, { month: 'short' })} ${today.getDate()},${today.toLocaleDateString(locale, { year: 'numeric' })}\n\n`;

export class RightSide extends Component<Props, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            donateAmountList: null,
            serviceBookingList: [],
            pancahngam: [],
            instantdonate: 0,
            selectedamount: 0,
            isemptyemail: false,
            userDetail: null,
            selectServiceId: null,
            selectServiceTypeId: null
        }
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
    }

    componentDidMount() {
        this.GetDynamicDropdownList();
        this.PageData();
        this.GetLoggedInUserDetails();
    }
    PageData = async () => {
        // // var result = await AdminService.GetPageContent("Layout", "LeftSideBar");
        // if (result && result.value) {
        //     var Pancahngam = result.value.filter(m => (m.title).toLowerCase() == "pancahngam");
        //     var TempleTimings = result.value.filter(m => (m.title).toLowerCase() == "templetimings");
        //     this.setState({ pancahngam: Pancahngam });
        // }
    }

    GetDynamicDropdownList = async () => {
        var data1 = await AdminService.GetDropdownValues("DonationTypes");
        // var data2 = await AdminService.GetDropdownValues("ServiceBooking");
        var data2 = await AdminService.GetQuickBookingList();

        if (data1 && data1.value && data2 && data2.value) {
            this.setState({ donateAmountList: data1.value, serviceBookingList: data2.value })
        }
    }
    GetLoggedInUserDetails = async () => {
        var result = JSON.parse(localStorage.getItem("user"));
        if (result && result.email) {
            this.setState({ userDetail: result });
        }
    }

    handleDropdownChange(e) {

        this.setState({ selectedamount: e.target.value });
    }
    DonateSubmit = async () => {
        let Donate = this.state.instantdonate;
        if (Donate > 0) {
            var url = "https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=" + this.state.instantdonate + "&currency_code=USD"
            var win = window.open(url, '_self');
            win.focus();
            this.setState({ instantdonate: null })
        }
        else {
            this.setState({ isemptyemail: true })
            return false;
        }
    }


    onChangeService = e => {
        debugger
        var Data = e.target.value.split(",")
        this.setState({
            selectServiceId: Data[0],
            selectServiceTypeId: Data[1],
        })
    }

    redirectToServiceRegistration = (cellInfo) => {
        debugger
        if (this.state.userDetail) {
            history.push(`/ServiceBooking/${this.state.selectServiceId}/${this.state.selectServiceTypeId}`);
            window.location.reload()
        }
        else {
            history.push(`/SignIn`)
        }
    }
    render() {
        const { donateAmountList, serviceBookingList, pancahngam, instantdonate, selectedamount, isemptyemail, userDetail } = this.state;

        return (
            <div>
                <div className="serv_book">
                    <h3><a href={userDetail ? "/ServiceBooking" : "/SignIn"}>Facility/Service Booking</a></h3>
                    <div className="help">
                        <p>Donate Today!</p>
                        <img src='https://static.wixstatic.com/media/d30db8_69c49621d0bf49c8b62cac7a263154eb~mv2.jpeg/v1/crop/x_10,y_0,w_323,h_326/fill/w_452,h_456,fp_0.50_0.50,lg_1,q_80,enc_avif,quality_auto/d30db8_69c49621d0bf49c8b62cac7a263154eb~mv2.jpeg'
                        width={"100%"} />
                        <p className='mt-3' style={{overflowWrap:'break-word'}}>Zelle ID:</p>
                        <p className='mt-1' style={{overflowWrap:'break-word'}}>donate2htcc@hindutempleofcolorado.net</p>

                    </div>
                    {/*<div className="help">
                        <p>Help us lower our loan Payment down by donating monthly</p>
                        <div id="recurringPayLebelId" onClick={this.handleDropdownChange}>
                            <select name="amount" className="popover__wrapper">
                                {donateAmountList ? donateAmountList.map(amount =>
                                    <option key={amount.value} value={amount.value}>{amount.text}</option>,

                                ) : null}
                            </select>

                        </div>
                        <a className="col-sm-3" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=" + this.state.selectedamount + "&currency_code=USD"} target="blank"><button name="submit">Donate Now</button></a>

                        <p className="reccur">
                            Recurring donation will continue indefinitely until cancelled
                        </p>
                    </div> */}
                    {/* <div className="help">
                        <p>Instant Donate</p>
                        <div className="paypaldonate">
                            <input type="number" placeholder="Amount" className="paypal_custom_donate_variable" name="amount" onChange={(e) => this.setState({ instantdonate: Number(e.target.value) })} />
                            <br />
                            <span className={(isemptyemail ? 'general-message-donate-right' : 'hide')}>Enter a valid Amount.</span>
                            <br />
                            <a className="col-sm-3" ><button className="payBtn" onClick={() => this.DonateSubmit()}>Submit</button></a> */}
                            {/* <a className="col-sm-3" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=" + this.state.instantdonate + "&currency_code=USD"} target="blank"><button name="submit" className="payBtn">Donate</button></a> */}
                        {/* </div>
                    </div> */}
                    {userDetail ? <div className="serv_booking" style={{ marginBottom: "25%" }}>
                        <div id="tempServiceLebel" >
                            <select className="popover__wrapper" onChange={this.onChangeService}>
                                <option value="0" disabled selected>Select Service</option>

                                {serviceBookingList ? serviceBookingList.map(service =>
                                    <option key={service.value} value={service.serviceId + "," + service.serviceTypeId}>{service.service}</option>
                                ) : null}
                            </select>
                            <div className="popover__select">
                                <p className="popover__select-message"></p>
                            </div>
                        </div>
                        <button className="book" onClick={this.redirectToServiceRegistration}>Service Booking</button>
                    </div> : null}
                    <div className="serv_booking">
                        <div id="tempServiceLebel">
                            <select className="popover__wrapper">
                                {serviceBookingList ? serviceBookingList.map(service =>
                                    <option key={service.value} value={service.value}>{service.text}</option>
                                ) : null}
                            </select>
                            <div className="popover__select">
                                <p className="popover__select-message"></p>
                            </div>
                        </div>
                        <button className="book">Service Booking</button>
                    </div>
                    {/* < div className="paper desk_view" >
                        <img src={tophandleimg} />
                        <div className="title-1">

                            <h4>Pancahngam</h4>
                            <div className="central wedge info" style={{ fontSize: "14px" }}>{currentDate}</div>
                            <div className="yoga-content">
                                {
                                    HTMLParser(pancahngam.length > 0 ? pancahngam[0].content : "")
                                }
                            </div>
                        </div>


                        <img src={bottomhandleimg} />
                    </div > */}
                </div>
            </div>
        );
    }
}
